import React from 'react';
import { GenericError } from '@thd-olt-component-react/error-components';

export const Generic = () => {
  return (
    <GenericError />
  );
};

Generic.propTypes = {};

Generic.defaultProps = {};
